import { injectable } from 'inversify';
import MessengerService from './messengerService';

@injectable()
class IgnoreMessengerService implements MessengerService {
  appointmentScheduled(): void {
    // Do nothing
  }
  cancelScheduling(): void {
    // Do nothing
  }
  finishedScheduling(): void {
    // Do nothing
  }
}

export default IgnoreMessengerService;
